import e from "react";
import { getIconColor as i } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const d = {
  display: "block"
}, f = ({ size: a = 16, useVw: o, useRem: c, color: n, withColor: l, removeClassName: t, disableSSR: m, style: r, ...p }) => {
  const v = r ? { ...d, ...r } : d;
  return /* @__PURE__ */ e.createElement(x, { disableSSR: m }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "32px-hezuo", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: o ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (c ? "rem" : "px"), height: o ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (c ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: v, fill: "none", ...p }, /* @__PURE__ */ e.createElement(
    "g",
    {
      className: t ? "" : "32px-åä½"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        clipRule: "evenodd",
        className: t ? "" : "normal",
        d: "M7.61 5.9a1.997 1.997 0 1 0 0 3.993 1.997 1.997 0 0 0 0-3.993ZM3.814 7.897a3.797 3.797 0 1 1 7.593 0 3.797 3.797 0 0 1-7.593 0ZM24.386 5.9a1.997 1.997 0 1 0 0 3.993 1.997 1.997 0 0 0 0-3.993ZM20.59 7.897a3.797 3.797 0 1 1 7.593 0 3.797 3.797 0 0 1-7.593 0ZM7.61 15.83a2.41 2.41 0 0 0-2.41 2.41v7.449c0 .416.339.755.755.755h3.31a.756.756 0 0 0 .756-.755v-2.483a.9.9 0 0 1 1.8 0v2.483a2.556 2.556 0 0 1-2.556 2.555h-3.31A2.556 2.556 0 0 1 3.4 25.69v-7.448a4.21 4.21 0 0 1 4.21-4.21c1.12 0 2.02.343 2.745 1 .691.626 1.168 1.486 1.57 2.41.549 1.254 1.68 1.858 2.675 2.15a.9.9 0 0 1-.507 1.728c-1.235-.363-2.964-1.206-3.817-3.159-.372-.853-.726-1.43-1.129-1.794-.369-.334-.827-.536-1.537-.536Zm14.032-.799c.726-.657 1.625-1 2.745-1a4.21 4.21 0 0 1 4.21 4.21v7.448a2.556 2.556 0 0 1-2.555 2.555h-3.31a2.556 2.556 0 0 1-2.556-2.555v-2.483a.9.9 0 0 1 1.8 0v2.483c0 .416.339.755.755.755h3.31a.756.756 0 0 0 .756-.755v-7.448a2.41 2.41 0 0 0-2.41-2.41c-.71 0-1.169.201-1.537.535-.404.365-.757.94-1.13 1.794-.852 1.953-2.58 2.796-3.816 3.159a.9.9 0 0 1-.508-1.727c.996-.293 2.127-.897 2.675-2.151m1.57-2.41c-.69.626-1.168 1.486-1.57 2.41Z",
        fillRule: "evenodd",
        fill: l ? i(n, 0, "#0B0C0D") : "#0B0C0D",
        datafollowfill: l ? i(n, 0, "#0B0C0D") : "#0B0C0D"
      }
    )
  )));
}, E = f;
export {
  E as default
};
